import { useMemo } from 'react';
import { useScreenDataMode } from '@/hooks/useScreenDataMode';
import { getDelegationService } from '../services/delegationService';
import type { DelegationService } from '../services/delegationService';

/**
 * Hook that returns the correct delegation service (mock or real)
 * based on the per-screen data mode configured in Settings > Screen Data Modes.
 *
 * Usage:
 * ```tsx
 * const { service, isDemo, isLive } = useDelegationService('approval-delegation');
 * const data = await service.getMyDelegations();
 * ```
 */
export const useDelegationService = (
  screenId: 'my-delegations' | 'approval-delegation' | 'approval-audit'
): { service: DelegationService; mode: 'demo' | 'live'; isDemo: boolean; isLive: boolean } => {
  const { mode, isDemo, isLive } = useScreenDataMode(screenId);
  const service = useMemo(() => getDelegationService(mode), [mode]);
  return { service, mode, isDemo, isLive };
};
